import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import { cloneDeep, concat, isArray, last } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ColumnCard from './ColumnCard';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import { checkArray, productListSubLocationsArray } from '../../../../../Components/helper';
import * as customAction from '../../../../RangePlan/CustomSections/store/CustomSections.action';
import * as action from '../../Store/CustomModule.action';

function AddEditColumnModal({ show, handleClose, tableColumns, tableControls, saveColumnData, editMode, editedIndex, maxColLimit, i }) {
  const [state, setState] = useState({
    columnStateData: [],
  });
  const [locationArray, setLocationArray] = useState([]);
  const [hideCustomModule, setHideCustomModule] = useState(false);
  const [rootAtLast, setRootAtLast] = useState(false);
  const [formulaHasError, setFormulaHasError] = useState(false);
  const { t } = useTranslation('common');
  const uniqueKey = uuidv4();
  const {
    customSectionData: { currSectionList },
  } = useSelector((reducer) => reducer);
  const { moduleLibId } = useParams();
  const [errors, setErrors] = useState([]);
  const [childOptions, setChildOptions] = useState([]);
  const [disableMainBtn, setDisableMainBtn] = useState(false);
  const { columnStateData } = state;
  const dummyData = { id: uniqueKey, key: '', label: '' };
  const dummyOption = { id: uniqueKey, name: '', label: '' };
  const keyHasOption = ['Dropdown', 'Multi_Dropdown', 'Check_Boxes', 'Ratio_Button'];

  const customLibraryCase = (val) => {
    return val?.control?.type === 'Table' ? state?.currentColumn?.type === 'string' : val?.control?.type === 'string';
  };

  const contextTableColumn = tableColumns;
  const dispatch = useDispatch();

  useEffect(() => {
    if (editMode) {
      setState((prevState) => ({
        ...prevState,
        columnStateData: [contextTableColumn[editedIndex]],
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        columnStateData: [dummyData],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hideShowSubLocation = (relation) => {
    return (
      ['Product_Core_Information', 'Product_Information', 'Supplier_Information', 'Specifications', 'Costing_Information'].includes(relation?.location?.name) ||
      (relation?.location?._id === 12 && relation?.output) ||
      (relation?.location?.name === 'Bill_of_Materials' && relation?.locationType?.name === 'single_bom_item' && relation?.output?.name === 'valueType') ||
      (relation?.location?.name === 'Samples' && relation?.attribute?.name) ||
      (relation?.location?.name === 'Purchase_Order' && relation?.attribute?.name === 'valueType') ||
      (relation?.location?.name === 'Completion_Indicator' && relation?.attribute?.name) ||
      relation?.location?._id === 7
    );
  };

  const hideShowOutput = (relation) => {
    if ((relation?.location?.name === 'Bill_of_Materials' || relation?.location?._id === 12) && relation?.attribute?.name === 'valueType') {
      return false;
    }
    return (
      ((['Design_Details', 'Testing', 'Bill_of_Materials', 'Care/User_Document_Information', 'Custom_Section'].includes(relation?.location?.name) ||
        relation?.location?._id === 12) &&
        relation?.attribute?.name) ||
      (relation?.location?.name === 'Purchase_Order' && state?.attribute?.name === 'all_item')
    );
  };

  const hideShowAttribute = (relation) => {
    return (
      [
        'Design_Details',
        'Specifications',
        'Testing',
        'Care/User_Document_Information',
        'Costing_Information',
        'Purchase_Order',
        'Product_Core_Information',
        'Product_Information',
        'Supplier_Information',
        'Completion_Indicator',
      ].includes(relation?.location?.name) ||
      relation?.location?._id === 12 ||
      (relation?.location?.name === 'Bill_of_Materials' && relation?.locationPlacement) ||
      (relation?.location?.name === 'Bill_of_Materials' && relation?.locationType?.name === 'all_item') ||
      (relation?.location?.name === 'Samples' && relation?.locationPlacement?.name)
    );
  };

  useEffect(() => {
    if (columnStateData?.length > 0) {
      const hasCalculationColumn = columnStateData.find((column) => column.key === 'Calculation');
      if (hasCalculationColumn?.relation?.locationArray && locationArray?.length === 0) {
        setLocationArray(hasCalculationColumn?.relation?.locationArray);
      }
    }
  }, [columnStateData, locationArray]);

  useEffect(() => {
    if (locationArray?.length > 0) {
      const opArray = [];
      locationArray?.forEach((val) => {
        const getSectionsColumns = cloneDeep(currSectionList?.find((ele) => val?.name === ele?._id));
        const locationValue = cloneDeep(productListSubLocationsArray?.find((subLocationArr) => val?._id === subLocationArr?.locationId));
        if (locationValue) {
          locationValue?.subLocations?.forEach((subEle) => {
            opArray.push({ id: `${subEle?.label}_(${val?.label})`, display: `${subEle?.label}_(${val?.label})` });
          });
        } else if (getSectionsColumns && isArray(getSectionsColumns?.columns) && getSectionsColumns?.columns.length > 0) {
          getSectionsColumns?.columns?.forEach((dyCol) => {
            opArray.push({ id: `${dyCol?.title}_(${val?.label})`, display: `${dyCol?.title}_(${val?.label})` });
          });
        }
      });
      setChildOptions(opArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationArray?.length, currSectionList, productListSubLocationsArray]);

  const hideShowPlacement = (relation) => {
    return (
      (relation?.location?.name === 'Bill_of_Materials' && relation?.locationType && relation?.locationType?.name !== 'all_item') ||
      (relation?.location?.name === 'Samples' && relation?.locationType?.name)
    );
  };

  const hideShowPage = (relation) => {
    return relation?.location?._id === 7 && relation?.subLocation;
  };
  const hideShowControl = (relation) => {
    return relation?.location?._id === 7 && relation?.subLocation && relation?.pages;
  };

  const validateSourceControl = (relation) => {
    let hasError = false;
    if (
      !relation.location ||
      (hideShowSubLocation(relation) && !relation?.subLocation) ||
      (['Bill_of_Materials', 'Samples'].includes(relation?.location?.name) && !relation?.locationType) ||
      (hideShowPlacement(relation) && !relation?.locationPlacement) ||
      (hideShowOutput(relation) && !relation?.output) ||
      (hideShowAttribute(relation) && !relation?.attribute) ||
      (hideShowPage(relation) && !relation?.pages) ||
      (hideShowControl(relation) && !relation?.control)
    ) {
      hasError = true;
    }
    return hasError;
  };

  const fixedRelationConditions = (relation) => {
    const hasEmptyContent = relation?.isContentArr?.some((element) => !element.isContent || !element.to);
    return !relation?.dropDownControl || hasEmptyContent;
  };
  const relativeRelationConditions = (relation) => {
    let valid = true;
    relation?.colourArray.forEach((element) => {
      if ((element?.colourValue && !element?.startPercentage) || (element?.colourValue === 'between' && !element?.endPercentage)) {
        valid = false;
      }
    });
    return !relation?.dropDownControl || !valid;
  };

  const validateDependentControl = (relation) => {
    let hasError = false;
    if (relation?.fixed ? fixedRelationConditions(relation) : relativeRelationConditions(relation)) {
      hasError = true;
    }
    return hasError;
  };

  const validateData = () => {
    const newErrors = columnStateData.map((item) => {
      if (
        !item.key?.trim() ||
        !item.fieldName?.trim() ||
        (item?.key === 'Source' && validateSourceControl(item.relation)) ||
        (item?.key === 'Calculation' && !item?.relation?.formulaArray?.length) ||
        (item?.key === 'Calculation' && item?.relation?.formulaArray.length === 1 && last(item?.relation?.formulaArray)?.subLocation?.label === '²') ||
        (item?.key === 'Calculation' &&
          item?.relation?.formulaArray?.length > 0 &&
          last(item?.relation?.formulaArray)?.subLocation?.type === 'symbol' &&
          ![')', '%', 'π', '²'].includes(last(item?.relation?.formulaArray)?.subLocation?.label)) ||
        (item?.key === 'Calculation' && item?.relation?.bracketCounter) ||
        (item?.key === 'Dependent' && validateDependentControl(item?.relation))
      ) {
        if (last(item?.relation?.formulaArray)?.subLocation?.name === '√') {
          setRootAtLast(true);
        } else if (item?.fieldName?.trim().length > 0 && item?.relation?.formulaArray?.length > 0) {
          setFormulaHasError(true);
        }
        return { error: true };
      }
      return { error: false };
    });

    const hasError = newErrors.some((item) => item.error === true);

    setErrors(newErrors);
    return !hasError;
  };

  const handleAddColumn = () => {
    if (validateData()) {
      if (contextTableColumn.length + columnStateData.length < maxColLimit) {
        setState((prevState) => ({
          ...prevState,
          columnStateData: [...columnStateData, dummyData],
        }));
      } else {
        toasterMsg('Columns maximum limit exceeded', 'danger');
      }
    }
  };

  const handleDeleteColumn = (deleteIndex) => {
    const data = cloneDeep(columnStateData);
    const newArray = [...data];
    newArray.splice(deleteIndex, 1);
    setState((prevState) => ({
      ...prevState,
      columnStateData: newArray,
    }));
  };

  const onChange = (value, index, attrName, childIndex) => {
    const data = columnStateData;
    const copyTableControl = cloneDeep(tableControls);
    const controlObj = copyTableControl?.find((eleControl) => eleControl?.key === value?.key);

    switch (attrName) {
      case 'key':
        data[index] = { ...controlObj };
        if (keyHasOption.includes(value?.key)) {
          data[index].options = [dummyOption];
        } else {
          delete data[index].options;
        }
        break;
      case 'range':
        data[index].range = value;
        break;
      case 'setDefault':
        data[index].statusColours.forEach((color, colIndex) => {
          data[index].statusColours[colIndex] = { ...color, setDefault: false };
        });
        data[index].statusColours[childIndex].setDefault = value;
        break;
      case 'colourHexCode':
        data[index].statusColours[childIndex].colourHexCode = value;
        break;
      case 'colourName':
        data[index].statusColours[childIndex].colourName = value;
        break;

      case 'colourValue':
        if (!data[index].colourArray) {
          data[index].colourArray = [
            {
              colourValue: '',
              colourType: 'green',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'amber',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'red',
              startPercentage: '',
              endPercentage: '',
            },
          ];
        }
        data[index].colourArray[childIndex].colourValue = value?._id;
        break;
      case 'startPercentage':
      case 'endPercentage':
        if (!data[index].colourArray) {
          data[index].colourArray = [
            {
              colourValue: '',
              colourType: 'green',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'amber',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'red',
              startPercentage: '',
              endPercentage: '',
            },
          ];
        }
        data[index].colourArray[childIndex][attrName] = value;
        break;
      default:
        data[index][attrName] = value;
        break;
    }

    setState((prevState) => ({
      ...prevState,
      columnStateData: data,
    }));
  };

  const setAttrinuteToValue = (getLocation, getLocationPlacment) => {
    return (
      ['Product_Core_Information', 'Product_Information', 'Supplier_Information', 'Specifications', 'Costing_Information', 'Completion_Indicator'].includes(
        getLocation,
      ) ||
      (getLocation === 'Samples' && ['earliest', 'mostRecent'].includes(getLocationPlacment))
    );
  };

  const fetchingCustomColumns = async (value) => {
    setState((oldState) => ({ ...oldState, loading: true }));
    if (value?.name) {
      const res = await dispatch(customAction.fetchCustomColumnList(value?.name));
      if (res) {
        setState((oldState) => ({ ...oldState, loading: false }));
      }
    }
  };

  const handleRemoArray = (removeArray, relation, colourIndex) => {
    removeArray.forEach((element) => {
      if (element === 'isContentArr') {
        relation.isContentArr = [{ isContent: null, to: '' }];
      } else if (colourIndex !== -1) {
        relation.colourArray[colourIndex][element] = null;
      } else if (element === 'colourArray') {
        relation[element] = [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ];
      } else {
        relation[element] = null;
      }
    });
  };

  const handleDependentChange = (key, value, removeArray, colourIndex, contentIndex, index) => {
    const clonedState = cloneDeep(columnStateData);
    const relation = clonedState?.[index]?.relation;
    if (key === 'dropDownControl') {
      const isControlOptions = value?.control?.options;
      relation.isControlOptions = isControlOptions;
      relation[key] = value;
    } else if (colourIndex !== -1) {
      relation.colourArray[colourIndex][key] = value;
    } else if (contentIndex !== -1) {
      relation.isContentArr[contentIndex][key] = value;
    } else {
      relation[key] = value;
    }
    relation.hasError = false;
    if (removeArray) {
      handleRemoArray(removeArray, relation, colourIndex);
    }
    if (relation.isControlOptions?.length === 1) {
      relation.isContentArr?.forEach((element) => {
        if (!element.isContent) {
          element.isContent = relation?.isControlOptions?.[0] || null;
        }
      });
    }
    clonedState[index].relation = relation;
    setState((prev) => ({ ...prev, columnStateData: clonedState }));
  };

  const addContent = (index) => {
    const clonedState = cloneDeep(columnStateData);
    const relation = clonedState?.[index]?.relation;
    relation.isContentArr.push({ isContent: null, to: '' });
    clonedState[index].relation = relation;
    setState((prev) => ({ ...prev, columnStateData: clonedState }));
  };

  const deleteCard = (index, ind) => {
    const clonedState = cloneDeep(columnStateData);
    const relation = clonedState?.[index]?.relation;
    relation.isContentArr.splice(ind, 1);
    clonedState[index].relation = relation;
    setState((prev) => ({ ...prev, columnStateData: clonedState }));
  };

  const handleChange = async (keyName, value, removeArray, index) => {
    delete value?.tableData;

    const clonedState = cloneDeep(columnStateData);
    clonedState[index].relation[keyName] = value;
    if (keyName === 'location' && value?._id === 12) {
      await fetchingCustomColumns(value);
    }
    if (keyName === 'subLocation' && clonedState[index].relation?.location?._id === 7) {
      setState((prev) => ({ ...prev, loading: true }));
      const res = await dispatch(action.getCMPagesList(value?.name));
      if (res) {
        setState((prev) => ({ ...prev, loading: false }));
      }
    }
    if (keyName === 'pages' && clonedState[index].relation?.location?._id === 7 && moduleLibId) {
      setState((prev) => ({ ...prev, loading: true }));
      const res = await dispatch(action.getCMPageControlList(clonedState[index].relation?.subLocation?.name, value?.name));
      if (res) {
        setState((prev) => ({ ...prev, loading: false }));
      }
    }
    if (removeArray && removeArray?.length > 0) {
      removeArray?.forEach((element) => {
        clonedState[index].relation[element] = null;
      });
    }
    if (
      setAttrinuteToValue(
        keyName === 'location' ? value?.name : clonedState[index].relation?.location?.name,
        keyName === 'locationPlacement' ? value?.name : clonedState[index].relation?.locationPlacement?.name,
      )
    ) {
      clonedState[index].relation.attribute = {
        label: 'Value',
        name: 'valueType',
      };
    }
    setState((prev) => ({ ...prev, columnStateData: clonedState }));
  };

  const updateFormulaString = (formulaArrays, index, clonedState) => {
    let getCurrFormulaString = '';
    let readOnlyFormulaString = '';
    if (clonedState[index]?.relation?.currLocation?.name === 'Custom_Modules') {
      formulaArrays?.forEach((formula) => {
        if (['symbol', 'Number'].includes(formula?.location?.type) || formula?.location?.name !== 'Custom_Modules') {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.subLocation?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.subLocation?.label, '');
        } else if (formula?.control?.type === 'Table') {
          getCurrFormulaString = getCurrFormulaString.concat(`${formula?.control?.name}_${formula?.column?.key}`, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(`${formula?.control?.label}_${formula?.column?.name}`, '');
        } else {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.control?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.control?.label, '');
        }
      });
    } else {
      formulaArrays?.forEach((formula) => {
        if (formula?.row) {
          getCurrFormulaString = getCurrFormulaString.concat(`${formula?.control?.name}_${formula?.column?.key}_${formula?.row?.rowIndex}`, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(`${formula?.control?.label}_${formula?.column?.name}_${formula?.row?.name}`, '');
        } else if (formula?.control) {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.control?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.control?.label, '');
        } else {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.subLocation?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.subLocation?.label, '');
        }
      });
    }
    clonedState[index].relation.formulaArray = formulaArrays;
    clonedState[index].relation.formulaString = getCurrFormulaString;
    clonedState[index].relation.readOnlyFormulaString = readOnlyFormulaString;
  };

  const createAndPushObj = (locationValue, clonedFormulaArray) => {
    const obj = {
      location: locationValue,
      subLocation: locationValue,
    };
    clonedFormulaArray.push(obj);
  };

  const onLocationChange = async (locationValue, keyName, index) => {
    const clonedState = cloneDeep(columnStateData);
    if (rootAtLast) {
      setRootAtLast(false);
    }
    if (formulaHasError) {
      setFormulaHasError(false);
    }
    if (errors?.[index]?.error) {
      errors[index].error = false;
    }
    if (keyName === 'subLocation' && clonedState[index]?.relation?.currLocation?.name === 'Custom_Modules') {
      const pageOptions = await dispatch(action.getCalculationPagesList(locationValue?.name));
      clonedState[index].relation.filteredPageArray = pageOptions;
    }
    if (
      keyName === 'page' &&
      clonedState[index]?.relation?.currSubLocation &&
      clonedState[index]?.relation?.currLocation?.name === 'Custom_Modules' &&
      locationValue
    ) {
      const pageControlOptions = await dispatch(action.getCalculationPageControlList(clonedState[index]?.relation?.currSubLocation?.name, locationValue?.name));
      const options = pageControlOptions?.data?.map((ele) =>
        ele?.control?.key === 'Table'
          ? {
              label: ele?.control?.labelInModal || ele?.control?.label,
              name: ele?.i,
              type: 'Table',
              tableColumns: ele?.control?.tableColumns
                ?.filter((e) =>
                  ['Heading', 'Text_Area', 'Textbox', 'Dropdown', 'Ratio_Button', 'Number_Decimal', 'Number_Percentage', 'Calculation'].includes(e?.key),
                )
                ?.map((e) => ({
                  name: e?.fieldName,
                  key: e?.key,
                  type: ['Number_Decimal', 'Number_Percentage', 'Calculation'].includes(e?.key) ? 'number' : 'string',
                })),
              tableRows: ele?.control?.tableData?.map((e, i) => ({ name: i + 1, rowIndex: i + 1 })),
            }
          : {
              label: ele?.control?.label,
              name: ele?.i,
              type: ['Number', 'Number_Decimal', 'Number_Percentage', 'Calculation'].includes(ele?.control?.key) ? 'number' : 'string',
            },
      );
      clonedState[index].relation.filteredControlsArray = options;
    }
    let clonedFormulaArray = clonedState[index]?.relation?.formulaArray;
    if (keyName === 'mainLoader') {
      clonedState[index].relation.mainLoader = locationValue;
    } else if (keyName === 'location') {
      let subLocationArray = clonedState[index].relation.filterSubLocation;
      if (locationValue?.name === 'Custom_Modules') {
        setHideCustomModule(true);
        subLocationArray = await dispatch(action.getAllCustomModuleForCalculations({ isAllRecord: true }));
      }
      clonedState[index].relation.counter = 0;
      clonedState[index].relation.currSubLocation = null;
      clonedState[index].relation.currLocation = locationValue;
      clonedState[index].relation.filterSubLocation = subLocationArray;
      clonedState[index].relation.subLocationArray = subLocationArray;
      clonedState[index].relation.currControl = null;
      clonedState[index].relation.currentColumn = null;
      clonedState[index].relation.currPage = null;
    } else if (keyName === 'currentColumn') {
      const obj = {
        location: clonedState[index].relation?.currLocation,
        subLocation: clonedState[index].relation?.currSubLocation,
        page: clonedState[index].relation?.currPage,
        control: clonedState[index].relation?.currControl,
        column: locationValue,
      };
      clonedFormulaArray = concat(clonedFormulaArray, obj);
      clonedState[index].relation.currentColumn = locationValue;
      clonedState[index].relation.counter = 1;
    } else if (keyName === 'control' && clonedState[index]?.relation?.currLocation?.name === 'Custom_Modules' && locationValue?.type === 'Table') {
      clonedState[index].relation.currControl = locationValue;
      clonedState[index].relation.currentColumn = null;
    } else if (keyName === 'control' && clonedState[index]?.relation?.counter === 0) {
      const obj = {
        location: clonedState[index]?.relation?.currLocation,
        subLocation: clonedState[index]?.relation?.currSubLocation,
        page: clonedState[index]?.relation?.currPage,
        control: locationValue,
      };
      clonedFormulaArray.push(obj);
      clonedState[index].relation.counter = 1;
      clonedState[index].relation.currControl = locationValue;
      clonedState[index].relation.currentColumn = null;
    } else if (keyName === 'page' && clonedState[index]?.relation?.counter === 0) {
      clonedState[index].relation.currPage = locationValue;
      clonedState[index].relation.currControl = null;
      clonedState[index].relation.currentColumn = null;
    } else if (keyName === 'subLocation' && clonedState[index].relation?.counter === 0 && isArray(locationValue?.name)) {
      if (clonedState[index]?.relation?.currLocation?.name === 'Custom_Modules') {
        clonedState[index].relation.currSubLocation = locationValue;
        clonedState[index].relation.counter = 1;
        clonedState[index].relation.currPage = null;
        clonedState[index].relation.currControl = null;
        clonedState[index].relation.currentColumn = null;
      } else {
        clonedFormulaArray = concat(clonedFormulaArray, locationValue?.name);
        clonedState[index].relation.counter = 1;
        clonedState[index].relation.currSubLocation = locationValue;
      }
    } else if (keyName === 'subLocation' && clonedState[index].relation?.counter === 0) {
      if (clonedState[index].relation?.currLocation?.name === 'Custom_Modules') {
        clonedState[index].relation.currSubLocation = locationValue;
        clonedState[index].relation.currPage = null;
        clonedState[index].relation.currControl = null;
        clonedState[index].relation.currentColumn = null;
      } else {
        const obj = {
          location: clonedState[index].relation?.currLocation,
          subLocation: locationValue,
        };
        clonedFormulaArray.push(obj);
        clonedState[index].relation.counter = 1;
        clonedState[index].relation.currSubLocation = locationValue;
      }
    } else if (['number', 'Number', 'Number_percentage'].includes(locationValue?.type)) {
      createAndPushObj(locationValue, clonedFormulaArray);
      clonedState[index].relation.counter = 1;
      clonedState[index].relation.currSubLocation = null;
      clonedState[index].relation.currPage = null;
      clonedState[index].relation.currControl = null;
      clonedState[index].relation.currentColumn = null;
    } else if (keyName === 'calcSymbol' && (['(', ')', '%'].includes(locationValue?.name) || locationValue?.specialCondition)) {
      createAndPushObj(locationValue, clonedFormulaArray);
      if (['('].includes(locationValue?.name)) {
        clonedState[index].relation.bracketCounter = (clonedState?.[index]?.relation?.bracketCounter || 0) + 1;
      }
      if (['π', '√', ')', 'X²'].includes(locationValue?.name)) {
        if ([')'].includes(locationValue?.name)) {
          clonedState[index].relation.bracketCounter = (clonedState?.[index]?.relation?.bracketCounter || 0) - 1;
        }
        clonedState[index].relation.counter = 1;
        clonedState[index].relation.currSubLocation = null;
        clonedState[index].relation.currPage = null;
        clonedState[index].relation.currControl = null;
        clonedState[index].relation.currentColumn = null;
      }
    } else if (keyName === 'calcSymbol' && clonedState[index].relation?.counter === 1) {
      createAndPushObj(locationValue, clonedFormulaArray);
      clonedState[index].relation.counter = 0;
      clonedState[index].relation.currSubLocation = null;
      clonedState[index].relation.currPage = null;
      clonedState[index].relation.currControl = null;
      clonedState[index].relation.currentColumn = null;
    } else if (clonedState[index].relation?.counter === 0) {
      toasterMsg(t('CUSTOM_LIBRARY.CALCULATION_TYPE.SELECT_SUBlOCATION'), 'info');
    } else {
      toasterMsg(t('CUSTOM_LIBRARY.CALCULATION_TYPE.SELECT_SYMBOL'), 'info');
    }
    if (clonedState[index].relation?.currLocation?.name === 'Custom_Modules' || locationValue?.name === 'Custom_Modules') {
      const foundCMFormulaString = clonedFormulaArray?.filter((val) =>
        val?.location?.name === 'Custom_Modules' ? customLibraryCase(val) : val?.control?.type === 'string',
      );
      const checkThisCMFormulaHasStringType = foundCMFormulaString?.length > 0;
      if (checkThisCMFormulaHasStringType) {
        clonedFormulaArray = clonedFormulaArray
          .filter((val) => !['(', ')', '%'].includes(val?.subLocation?.name))
          .map((eleFormula) => {
            let formula = eleFormula;
            if (formula?.subLocation?.type === 'symbol') {
              formula = {
                location: { name: '&', label: '&', type: 'symbol' },
                subLocation: { name: '&', label: '&', type: 'symbol' },
              };
            }
            return formula;
          });
      }
      updateFormulaString(clonedFormulaArray, index, clonedState);
      clonedState[index].relation.undo = [...(clonedState?.[index]?.relation?.undo, []), ...clonedFormulaArray];
      clonedState[index].relation.redo = [];
    } else {
      const foundFormulaString = clonedFormulaArray?.filter((val) =>
        val?.location?.name === 'Custom_Modules' ? customLibraryCase(val) : val?.subLocation?.type === 'string',
      );
      const checkThisFormulaHasStringType = foundFormulaString?.length > 0;
      if (checkThisFormulaHasStringType) {
        clonedFormulaArray = clonedFormulaArray
          .filter((val) => !['(', ')', '%'].includes(val?.subLocation?.name))
          .map((eleFormula) => {
            let formula = eleFormula;
            if (formula?.subLocation?.type === 'symbol') {
              formula = {
                location: { name: '&', label: '&', type: 'symbol' },
                subLocation: { name: '&', label: '&', type: 'symbol' },
              };
            }
            return formula;
          });
      }
      updateFormulaString(clonedFormulaArray, index, clonedState);
      clonedState[index].relation.undo = [...(clonedState[index]?.relation?.undo || []), ...clonedFormulaArray];
      clonedState[index].relation.redo = [];
    }
    setState((prev) => ({ ...prev, columnStateData: clonedState, errors }));
  };

  // Function to count options with empty label or value
  const countOptionsWithEmptyLabelOrValue = () => {
    let count = 0;

    columnStateData.forEach((item) => {
      if (item?.key === 'Company_Stamp') {
        if (item.companyLogo === '') {
          count += 1;
        }
      } else if (item?.key === 'Signature') {
        if (item?.placeholder === '' && item?.digitalSignPath === '') {
          count += 1;
        }
      } else {
        item?.options?.forEach((option) => {
          if (option.label?.trim() === '' || option.value?.trim() === '') {
            count += 1;
          }
        });
      }
    });

    return count === 0;
  };

  function filterObjectByArray(obj, keysArr) {
    const filteredObj = {};
    keysArr.forEach((key) => {
      if (obj.hasOwnProperty(key)) {
        filteredObj[key] = obj[key];
      }
    });
    return filteredObj;
  }

  const handleAddEditCol = () => {
    if (validateData()) {
      if (countOptionsWithEmptyLabelOrValue()) {
        const finalData = columnStateData?.map((ele) => {
          if (ele?.key === 'Source') {
            ele.relation = filterObjectByArray(ele?.relation, [
              'location',
              'subLocation',
              'attribute',
              'output',
              'locationType',
              'locationPlacement',
              'pages',
              'control',
              'tableColumn',
            ]);
          } else if (ele?.key === 'Calculation') {
            ele.relation = filterObjectByArray(ele?.relation, ['formulaArray', 'formulaString', 'readOnlyFormulaString']);
          }
          return ele;
        });
        saveColumnData(finalData);
      } else {
        toasterMsg('Options/Image/Signature required for selected column(s)', 'danger');
      }
    }
  };

  const handleOptionChange = (ele, optionIndex, colIndex, controlKey) => {
    const data = columnStateData;
    data[colIndex].options[optionIndex].name = ele.target.value;
    data[colIndex].options[optionIndex].label = ele.target.value;
    if (controlKey === 'Multi_Dropdown' || controlKey === 'Dropdown') {
      data[colIndex].options[optionIndex].value = ele.target.value;
      delete data[colIndex].options[optionIndex].name;
    }
    setState((prevState) => ({
      ...prevState,
      columnStateData: data,
    }));
  };

  const handleBlurOption = (optionIndex, colIndex) => {
    const updatedData = [...columnStateData];
    const { label, value, ...restOptions } = updatedData[colIndex].options[optionIndex];

    updatedData[colIndex].options[optionIndex] = {
      ...restOptions, // Spread existing properties
      label: label?.trim(),
      value: value?.trim(),
    };

    setState((prevState) => ({
      ...prevState,
      columnStateData: updatedData,
    }));
  };

  const handleBlur = (colIndex, attrName) => {
    const updatedData = [...columnStateData];
    updatedData[colIndex][attrName] = updatedData[colIndex][attrName]?.trim();
    setState((prevState) => ({
      ...prevState,
      columnStateData: updatedData,
    }));
  };

  const checkEmptyOption = async (colIndex) => {
    const colData = columnStateData;
    return colData[colIndex].options.filter((ele) => ele.label?.trim() === '');
  };
  const handleAddMoreOption = async (colIndex) => {
    const emptyOptions = await checkEmptyOption(colIndex);
    if (emptyOptions.length === 0) {
      const data = columnStateData;
      data[colIndex].options = [...data[colIndex].options, dummyOption];
      setState((prevState) => ({
        ...prevState,
        columnStateData: data,
      }));
    } else {
      toasterMsg('Options required for selected column(s)', 'danger');
    }
  };
  const handleDeleteOption = (optIndex, colIndex) => {
    const data = cloneDeep(columnStateData);
    const newArray = [...data[colIndex].options];
    newArray.splice(optIndex, 1);

    data[colIndex].options = newArray;
    setState((prevState) => ({
      ...prevState,
      columnStateData: data,
    }));
  };

  const changeRelationState = (index, keyName, value) => {
    const clonedState = cloneDeep(columnStateData);
    clonedState[index].relation[keyName] = value;
    setState((prev) => ({ ...prev, columnStateData: clonedState }));
  };

  return (
    <Modal className="common-custom-modal modal-large" show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>{editMode ? t('CUSTOM_LIBRARY.STATIC_CONTROLS.EDIT_COLUMN') : t('CUSTOM_LIBRARY.STATIC_CONTROLS.ADD_COLUMN')}</Modal.Title>
        <span onClick={handleClose} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        <div className="column-container">
          {columnStateData?.length > 0 &&
            columnStateData.map((ele, colIndex) => {
              const selectValue = checkArray(tableControls) && tableControls?.find((eleControl) => eleControl?.key === ele?.key);
              return (
                <ColumnCard
                  key={ele?.id}
                  colIndex={colIndex}
                  element={ele}
                  tableControls={tableControls}
                  selectValue={selectValue}
                  onChange={onChange}
                  keyHasOption={keyHasOption}
                  handleOptionChange={handleOptionChange}
                  handleBlurOption={handleBlurOption}
                  handleBlur={handleBlur}
                  errors={errors}
                  columnStateData={columnStateData}
                  handleAddColumn={handleAddColumn}
                  editMode={editMode}
                  handleDeleteColumn={handleDeleteColumn}
                  handleAddMoreOption={handleAddMoreOption}
                  handleDeleteOption={handleDeleteOption}
                  handleChange={handleChange}
                  handleDependentChange={handleDependentChange}
                  relation={ele?.relation}
                  changeRelationState={changeRelationState}
                  onLocationChange={onLocationChange}
                  setState={setState}
                  addContent={addContent}
                  deleteCard={deleteCard}
                  i={i}
                  childOptions={childOptions}
                  setDisableMainBtn={setDisableMainBtn}
                  hideCustomModule={hideCustomModule}
                  rootAtLast={rootAtLast}
                  formulaHasError={formulaHasError}
                  setFormulaHasError={setFormulaHasError}
                />
              );
            })}
        </div>
        <div className="common-model-footer mt-16">
          <button type="button" className="btn p-0" onClick={handleAddEditCol} disabled={disableMainBtn} aria-label="save">
            <i className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddEditColumnModal;
